module.exports = __webpack_public_path__ + "static/media/Wholly_schnit.8c215e83.png";